import { action, observable, makeObservable } from 'mobx';
import { IInstantNotificationSettings, NotificationType } from 'stores/_shared/Interfaces';

export interface IAdminNotification {
    id?: string;
    schedule?: string;
    name?: string;
    subject?: string;
    createdBy?: string;
    editedBy?: string;
    notificationType: NotificationType;
    enabled?: boolean;
    timezone?: string;
    timezoneOffset?: number;
    data?: IInstantNotificationSettings;
    createdOn?: string;
    updatedOn?: string;
    recipients?: Array<string>;
    organizationId?: string;
    locationId?: string;
    frequency?: string;
}

export default class AdminNotificationStore {
    notification: IAdminNotification = {
        notificationType: NotificationType.ALERT_DIGEST,
        schedule: '0 8 * * *',
        enabled: true
    };

    constructor(notification: IAdminNotification) {
        makeObservable(this, {
            notification: observable,
            update: action
        });

        this.update(notification);
    }

    update(notification: IAdminNotification): void {
        this.notification = {
            ...this.notification,
            ...notification
        };
    }
}
